import React from 'react';
require('../../css/components/LoginDialog.scss');

'use strict';

export default class LoginDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { facilities: this.props.facilities, error: false, selectedFacility: 0, selectedPasscode: null };
    }

    componentDidMount() {
        if (this.props.selectFromList && this.props.apiUrl)
            fetch(this.props.apiUrl)
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            facilities: result.facilities
                        });
                    },
                    (error) => {
                        this.setState({
                            error: true
                        });
                    }
            );
    }

    changeSelectedFacility(event) {
        this.setState({ selectedFacility: event.target.selectedIndex, selectedPasscode: event.target.value });
    }

    submitPasscode(event) {
        this.props.setLoggedIn(true, this.state.selectedPasscode);
    }

    changeEnteredPasscode(event) {
        this.setState({ selectedPasscode: event.target.value });
    }

    handleKeyUp(event) {
        if (event.keyCode === 13) {
            this.verifyPasscode();
        }
    }

    verifyPasscode() {
        fetch(this.props.apiUrl + '/' + this.state.selectedPasscode)
            .then(res => res.json())
            .then(
            (result) => {
                if (result.passcode === this.state.selectedPasscode) {
                    this.props.setLoggedIn(true, result.passcode);
                    this.setState({
                        error: false
                    });
                }
                else {
                    this.setState({
                        error: true
                    });
                }
                },
                (error) => {
                    this.setState({
                        error: true
                    });
                }
            );
    }

    render() {
        var facilities = [];

        if (this.state.facilities && this.state.facilities.length) {
            facilities.push(React.createElement('option', { key: 0 }, this.props.copy.selectHospital));

            var index = 1;
            facilities.push(
                this.state.facilities.filter(facility => {
                    return facility.passcode !== null;
                }).map(facility => {
                    return React.createElement('option', { key: index++, value: facility.passcode }, facility.name || facility.passcode);
                })
            );
        }
        else
            if (this.state.error)
                facilities.push(React.createElement('option', { key: 0 }, this.props.copy.errorLoadingHospitals));
            else
                if (!facilities)
                    facilities.push(React.createElement('option', { key: 0 }, this.props.copy.loadingHospitals));

        var header = [];

        if (this.props.showLogo)
            header.push(
                React.createElement(
                    'img', { key: 'img', src: '/img/healthclips-online.svg' })
            );

        if (this.props.enableDismiss)
            header.push([
                React.createElement(
                    'button', { key: 'button', type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'close' },
                React.createElement(
                    'span', { 'aria-hidden': 'true' }, String.fromCharCode(215)))
            ]);

        return React.createElement(
            'div', { className: 'loginDialog' },
            [
                React.createElement(
                    'div', { key: 'header', className: 'modal-header' },
                    header
                ),
                this.props.selectFromList ?
                    React.createElement(
                        'div', { key: 'body', className: 'modal-body' },
                        [
                            React.createElement(
                                'p', { key: 'p', className: 'loginDialog__sub-heading' }, this.props.copy.selectPasscode)
                        ],
                        facilities.length ? React.createElement(
                            'select', { key: 'select', defaultValue: this.state.value, onChange: this.changeSelectedFacility.bind(this) }, facilities) : null,
                    ) :
                    React.createElement(
                        'div', { key: 'body', className: 'modal-body' },
                        [
                            React.createElement(
                                'p', { key: 'p', className: 'loginDialog__sub-heading', dangerouslySetInnerHTML: { __html: this.props.copy.enterPasscodeHeading } })
                        ],
                        React.createElement(
                            'input', { key: 'input', onKeyUp: this.handleKeyUp.bind(this), placeholder: this.props.copy.enterPasscode, onChange: this.changeEnteredPasscode.bind(this) }),
                    ),
                React.createElement(
                    'div', { key: 'footer', className: 'modal-footer' },
                    [
                        this.props.selectFromList ?
                            (facilities.length ?
                                React.createElement(
                                    'button',
                                    {
                                        key: 0, type: 'button', className: 'btn btn-success', 'data-dismiss': 'modal', disabled: this.state.selectedFacility === 0,
                                        onClick: this.submitPasscode.bind(this)
                                    },
                                    this.props.copy.loginNow) :
                                null) :
                        React.createElement(
                            'div',
                            {
                                key: 0, className: ''
                            }, [
                                React.createElement(
                                    'div',
                                    {
                                        key: 0, className: 'modal-error-message'
                                    },
                                    this.state.error || this.props.displayInvalidPasscodeMessage ? this.props.copy.invalidPasscode : null)
                                ,
                                React.createElement(
                                    'button',
                                    {
                                        key: 1, type: 'button', className: 'btn btn-success',
                                        onClick: this.verifyPasscode.bind(this)
                                    },
                                    this.props.copy.loginNow)
                                ]
                            )
                    ]
                )
            ]
        );
    }
}
